module.exports=
{
    phonePattern:/^\d{8}$/
}